const styles = {
  container: {
    padding: '40px 48px'
  },
  message: {
    animationDuration: '10s',
    animationName: 'slidein',
    animationIterationCount: 'infinite'
  },
  plateBadge: {
    border: '1px solid #d9d9d9',
    borderRadius: 8,
    padding: '12px 24px',
    background: '#fff',
    textAlign: 'center'
  }
};

export default styles;
